import { message } from 'antd';
import moment from 'moment';
import { DEFAULT_FORMATTER, getColumnString } from '@/presentation/components/compare/api';
import {
  CompareItem,
  CompareStore,
  isSameCompareItem,
  oneDayLimit,
} from '@/presentation/components/compare/store';
import { getColumn, newColumn } from '@/presentation/pages/memory/analytics/trend/compare/column';
import { FieldKey } from '@/proto/field';
import { MetricSubType, MetricType } from '@/proto/metric';

export const getStoreKey = (metricType: MetricType, metricSubType?: MetricSubType) => `${metricType}-${metricSubType}`;

export const newAddToCompareList = (
  fields: Record<string, any>,
  metricType: MetricType,
  metricSubType?: MetricSubType,
  token?: string,
) => {
  const filterFields = {
    ...fields,
    [FieldKey.TimeRange]: fields?.date_value
      ?.map?.((item: any) => moment.unix(item).format(DEFAULT_FORMATTER)),
  };
  const item = {
    token,
    id: getColumnString(newColumn(metricType), filterFields),
    fields: filterFields,
  };
  try {
    compareStore.addItem(getStoreKey(metricType, metricSubType), item, false);
  } catch (error: any) {
    message.warning(error.message);
  }
};


export const addToCompareList = (
  fields: Record<string, any>,
  metricType: MetricType,
  metricSubType?: MetricSubType,
) => {
  const filterFields = {
    ...fields,
    [FieldKey.TimeRange]: fields[FieldKey.TimeRange]
      .map((item: any) => moment(item).format(DEFAULT_FORMATTER)),
  };
  const item = {
    id: getColumnString(getColumn(metricType), filterFields),
    fields: filterFields,
  };
  try {
    compareStore.addItem(getStoreKey(metricType, metricSubType), item, false);
  } catch (error: any) {
    message.warning(error.message);
  }
};

export const compareStore = new CompareStore<CompareItem>({
  canAdd: oneDayLimit,
  isSame: isSameCompareItem,
});
